var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"area-divider","content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }